import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { CategoryDto, CategoryService, UserService } from '@api-client';
import { ModalService, ToastService } from '@front-share';
import { LepiIcon } from '@lepisode-ui/components';
import { startWith } from 'rxjs';
import { AutoAnimateDirective } from '../../../animations/auto-animate.directive';
import { ButtonComponent } from '../../../components/button/button.component';
import { ScreenSizeService } from '../../../services/screen-size.service';
import { UserAuthStore } from '../../../stores/user.store';
import { NavAccordionComponent } from '../nav-accordion/nav-accordion.component';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [
    CommonModule,
    LepiIcon,
    ButtonComponent,
    NavAccordionComponent,
    RouterModule,
    AutoAnimateDirective,
  ],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent {
  modalService = inject(ModalService);
  toastService = inject(ToastService);
  categoryService = inject(CategoryService);
  isMobile = inject(ScreenSizeService).isMobile;
  router = inject(Router);
  userService = inject(UserService);
  user = inject(UserAuthStore).user;
  userAuthStore = inject(UserAuthStore);

  topLevelCategoryList = toSignal(
    this.categoryService.categoryControllerFindAllTree()?.pipe(startWith([])),
  );

  logout() {
    this.userService.userControllerLogout().subscribe({
      next: () => {
        this.modalService.close();
        this.userAuthStore.setUser(null);
        this.toastService.success('로그아웃 되었습니다.');
        this.router.navigate(['/'], { replaceUrl: true });
      },
    });
  }

  async handleMyPage() {
    this.modalService.close();
    this.router.navigateByUrl('/my-page', { replaceUrl: true });
  }

  //예약내역
  async history() {
    if (this.user()) {
      this.modalService.close();

      this.router.navigateByUrl('/my-page/history', { replaceUrl: true });
    } else {
      this.toastService.info('로그인을 해주세요');
    }
  }

  //매거진
  async magazine() {
    this.modalService.close();
    this.router.navigateByUrl('/magazine', { replaceUrl: true });
  }

  //내활동
  async activity() {
    if (this.user()) {
      this.modalService.close();

      this.router.navigateByUrl('/my-page/activity', { replaceUrl: true });
    } else {
      this.toastService.info('로그인을 해주세요');
    }
  }

  //상품 카테고리로 이동
  moveTo(category: CategoryDto) {
    this.modalService.close();
    this.router.navigate(['/product'], {
      queryParams: {
        category: category?.id,
      },
    });
  }

  close() {
    this.modalService.close();
  }
}
